module.exports = __webpack_public_path__ + "img/logo.d1476c6b.png";